<div class="kw-page" [nbSpinner]="this.isLoading">

  <button mat-button class="back-btn" type="button" (click)="back()">
    <fa-icon [icon]="faArrowLeft" class="me-2"></fa-icon>Back
  </button>

  <ng-container *ngIf="this.hum">

    <div class="detail-card detail-hero">
      <div class="hero-left">
        <div class="hero-avatar"><fa-icon [icon]="faBox"></fa-icon></div>
        <div class="hero-info">
          <h1 class="hero-title">
            {{this.hum.barcode}}
            <span class="inactive-pill" *ngIf="!this.humIsActive">Inactive</span>
          </h1>
          <div class="hero-meta">
            <span class="meta-item" *ngIf="getLocation()">
              <fa-icon [icon]="faLocationDot" class="meta-icon"></fa-icon>{{getLocation()}}
            </span>
            <span class="meta-item">
              <fa-icon [icon]="faListUl" class="meta-icon"></fa-icon>{{this.hum.handlingUnitDetails.length}} item{{this.hum.handlingUnitDetails.length === 1 ? '' : 's'}}
            </span>
            <span class="meta-item">
              <fa-icon [icon]="faLayerGroup" class="meta-icon"></fa-icon>Total Qty {{getRowQTY(this.hum) | number}}
            </span>
          </div>
          <div class="hero-pills">
            <span class="status-tag" *ngIf="statusName" [ngClass]="getStatusClass(statusName)"><span class="status-dot"></span>{{statusName}}</span>
            <span class="type-pill" *ngIf="this.hum.orderNumber"><span class="pill-kind">Order</span>{{this.hum.orderNumber}}</span>
          </div>
        </div>
      </div>

      <div class="hero-actions">
        <button mat-raised-button color="primary" class="primary-action" type="button" (click)="adjustQty()">
          <fa-icon [icon]="faSlidersH" class="me-2"></fa-icon>Adjust Qty
        </button>
        <button mat-stroked-button type="button" (click)="moveInventory()">
          <fa-icon [icon]="faTruck" class="me-2"></fa-icon>Move
        </button>
        <button mat-stroked-button type="button" (click)="transferInventory()">
          <fa-icon [icon]="faRightLeft" class="me-2"></fa-icon>Transfer
        </button>
        <button mat-stroked-button type="button" *ngIf="this.humIsActive" [class.active]="this.isPrint" (click)="reprintInventory()">
          <fa-icon [icon]="faPrint" class="me-2"></fa-icon>Print
        </button>
        <button mat-stroked-button class="more-btn" type="button" aria-label="More actions" *ngIf="this.humIsActive" [matMenuTriggerFor]="moreMenu">
          <fa-icon [icon]="faEllipsisVertical"></fa-icon>
        </button>
        <mat-menu #moreMenu="matMenu" xPosition="before">
          <button mat-menu-item type="button" *ngIf="this.removedDetails.length" (click)="restoreRemovedItem()">
            <fa-icon [icon]="faTrashRestore" class="me-2"></fa-icon>Restore Removed
          </button>
          <button mat-menu-item type="button" class="danger-item" (click)="removeInventory()">
            <fa-icon [icon]="faTrashAlt" class="me-2"></fa-icon>Remove
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="detail-card quick-edit">
      <div class="quick-field">
        <label for="humStatus">Status</label>
        <mat-form-field appearance="outline" class="quick-input">
          <mat-select id="humStatus" [(ngModel)]="this.newStatusId" name="status" (ngModelChange)="setStatus()">
            <mat-option *ngFor="let status of this.allStatuses" [value]="status.id">
              {{status.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="quick-field">
        <label for="humOrderNumber">Order #</label>
        <div class="quick-row">
          <mat-form-field appearance="outline" class="quick-input">
            <input id="humOrderNumber" type="text" [(ngModel)]="this.newOrderNumber" matInput (keyup.enter)="updateOrder()" />
          </mat-form-field>
          <button mat-stroked-button class="quick-save" type="button" (click)="updateOrder()">Save</button>
        </div>
      </div>
    </div>

    <div class="detail-card print-panel" *ngIf="this.isPrint">
      <div class="quick-field">
        <label for="humPrinter">Printer</label>
        <mat-form-field appearance="outline" class="quick-input">
          <mat-select id="humPrinter" required name="selectedPrinter" [(ngModel)]="this.selectedPrinter.id"
            (selectionChange)="selectPrinter($event.value)">
            <mat-option *ngFor="let p of this.printers" [value]="p.id">
              {{p.name}} ({{p.status}})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="print-actions">
        <button mat-stroked-button type="button" (click)="reprintInventory()">Cancel</button>
        <button mat-raised-button color="primary" type="button" [disabled]="!this.selectedPrinter.id" (click)="print()">
          <fa-icon [icon]="faPrint" class="me-2"></fa-icon>Send Print Job
        </button>
      </div>
    </div>

    <div class="detail-main">
      <div class="detail-card items-card">
        <div class="card-bar">
          <h3>Items</h3>
          <span class="count-pill">{{this.itemRows.length}}</span>
          <button mat-stroked-button class="card-bar-action" type="button" (click)="addItem()">
            <fa-icon [icon]="faPlus" class="me-2"></fa-icon>Add {{"Product" | tenantWords}}
          </button>
        </div>

        <div class="grid-card">
          <ejs-grid [dataSource]="this.itemRows" [columns]="this.gridColumns" [allowTextWrap]="true"></ejs-grid>
        </div>

        <div class="kw-mobile-list">
          <div class="m-card" *ngFor="let row of this.itemRows; trackBy: trackByItem">
            <div class="m-card-top">
              <span class="m-card-name">{{row.itemName}}</span>
              <button mat-icon-button type="button" aria-label="Edit item" (click)="edit(row)">
                <fa-icon [icon]="faPen"></fa-icon>
              </button>
            </div>
            <div class="m-card-meta">
              <div class="m-meta-line">
                Lot&nbsp;<a class="lot-link" (click)="lotNumberClick(row)">{{row.lotNumber}}</a>
                <ng-container *ngIf="row.varietyName">&nbsp;· {{row.varietyName}}</ng-container>
              </div>
              <div class="m-meta-sub" *ngIf="row.attributeSummary">{{row.attributeSummary}}</div>
            </div>
            <div class="m-card-foot">
              <span class="type-pill">Qty {{row.quantity | number:'1.0-2'}}<ng-container *ngIf="row.packageSummary"> · {{row.packageSummary}}</ng-container></span>
              <span class="m-card-note" *ngIf="row.expiration">Expires {{row.expiration | date:'shortDate'}}</span>
            </div>
          </div>
          <div class="m-empty" *ngIf="!this.itemRows.length">No items on this unit</div>
        </div>
      </div>

      <inventory-transaction-timeline [transactions]="this.hum.transactions"></inventory-transaction-timeline>
    </div>

  </ng-container>
</div>

<ng-template #lotTemplate let-data>
  <a class="lot-link" (click)="lotNumberClick(data)">{{data.lotNumber}}</a>
</ng-template>

<ng-template #quantityTemplate let-data>
  <div>{{data.quantity | number:'1.0-2'}}</div>
  <div class="item-sub" *ngIf="data.packageSummary">{{data.packageSummary}}</div>
</ng-template>

<ng-template #actionTemplate let-data>
  <div class="row-actions">
    <button mat-icon-button type="button" aria-label="Edit item" (click)="edit(data)">
      <fa-icon [icon]="faPen"></fa-icon>
    </button>
  </div>
</ng-template>
